'use client'

import styles from './styles.module.scss'

export default function AiIcon() {
  return (
    <div className={styles.aiIcon}>
      <div className={styles.aiIconInner}>
        <span className={styles.iconText}>AI</span>
      </div>
    </div>
  )
}
